import {
  SetupCheckpointStatusSchema,
  type SetupCheckpointStatus as GeneratedSetupCheckpointStatus
} from '~/services/api/generated'

export type SetupCheckpointStatus = GeneratedSetupCheckpointStatus

export const SetupCheckpointStatus = {
  NOT_STARTED: SetupCheckpointStatusSchema.enum.not_started,
  IN_PROGRESS: SetupCheckpointStatusSchema.enum.in_progress,
  COMPLETE: SetupCheckpointStatusSchema.enum.complete
} satisfies Record<string, GeneratedSetupCheckpointStatus>

export const SetupCheckpointStatusValues: readonly GeneratedSetupCheckpointStatus[] = [
  SetupCheckpointStatusSchema.enum.not_started,
  SetupCheckpointStatusSchema.enum.in_progress,
  SetupCheckpointStatusSchema.enum.complete
]
